import React from 'react';
import { Link } from 'react-router-dom';

const features = [
  {
    title: 'Replies to new leads instantly',
    desc: 'Responds in seconds — day or night, no matter how busy you are.',
  },
  {
    title: 'Qualifies customers automatically',
    desc: 'Asks the right questions and filters serious buyers before you lift a finger.',
  },
  {
    title: 'Books appointments for you',
    desc: 'Syncs with your calendar and confirms bookings automatically.',
  },
  {
    title: 'Follows up until they convert',
    desc: 'Never lets a warm lead go cold again.',
  },
];

export default function AIFeature() {
  return (
    <section className="py-32 px-6 w-full" style={{ background: '#061a12' }}>
      <div className="max-w-[1100px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <p className="text-xs font-mono uppercase tracking-widest mb-4 font-semibold" style={{ color: '#d4f542' }}>AI Automation</p>
            <h2 className="text-4xl md:text-5xl font-bold text-white tracking-tight leading-tight mb-6">
              Your AI Assistant<br />Works{' '}
              <span style={{ color: '#d4f542' }}>24/7</span>
            </h2>
            <p className="text-lg font-medium italic mb-10" style={{ color: 'rgba(255,255,255,0.55)' }}>
              "Never miss another client again."
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2.5 px-7 py-3.5 rounded-xl text-sm font-bold transition duration-200"
              style={{ background: '#d4f542', color: '#082318' }}
              onMouseEnter={e => e.currentTarget.style.background = '#c8e830'}
              onMouseLeave={e => e.currentTarget.style.background = '#d4f542'}
            >
              See It In Action
              <svg width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M2 12L12 2M12 2H5M12 2v7" />
              </svg>
            </Link>
          </div>

          {/* Right */}
          <div className="space-y-4">
            {features.map((f, i) => (
              <div
                key={i}
                className="flex items-start gap-5 p-6 rounded-2xl"
                style={{ background: '#0c2d1e', border: '1px solid rgba(255,255,255,0.07)' }}
              >
                <div
                  className="flex items-center justify-center w-9 h-9 rounded-xl text-xs font-bold flex-shrink-0 font-mono"
                  style={{ background: 'rgba(212,245,66,0.12)', color: '#d4f542' }}
                >
                  {String(i + 1).padStart(2, '0')}
                </div>
                <div>
                  <p className="font-semibold text-white mb-1">{f.title}</p>
                  <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
